import { AxiosError } from "axios";
import { SessionManager } from "../SessionManager/SessionManager";

const errorMessages = {
    networkError: "Unable to connect to the server.",
    unauthorizedAccess: "Unauthorized access. Please login to continue."
}

export default class NetworkErrorHandler {
    
    private isRedirectingToLogin = false;

    public handleError(error: any): string {
        const serverResponse = error.response

        if (serverResponse && serverResponse.data) 
            return this.handleServerError(serverResponse);
        else 
            return this.handleAxiosError(error as AxiosError);
    }

    private handleAxiosError(error: AxiosError): string {

        switch(error.code) {
            case "ERR_NETWORK": 
                return errorMessages.networkError;
            default:
                return error.message
        }
    }

    private handleServerError(serverResponse: any): string {

        switch(serverResponse.status) {
            case 401: 
            case 403: {
                const wasLoggedIn = SessionManager.shared.isLoggedin();
                SessionManager.shared.signOut();
                if (wasLoggedIn && !this.isRedirectingToLogin && !window.location.pathname.startsWith('/login')) {
                    this.isRedirectingToLogin = true;
                    window.location.replace('/login');
                }
                return errorMessages.unauthorizedAccess;
            }
            default:
                return serverResponse.data.message;
        }
    }

}